import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService } from "@sick-bust-sts/sts-core";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
  standalone: false,
})
export class LoginComponent implements OnInit {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
  ) {}

  ngOnInit(): void {
    if (this.authenticationService.isLoggedIn()) {
      void this.router.navigate(["home"]);
    }
  }

  public onClick(): void {
    this.login();
  }

  public onKeyUp(event: KeyboardEvent): void {
    if (event.key !== "Enter") {
      return;
    }

    this.login();
  }

  private login(): void {
    void this.authenticationService.startAuthentication();
  }
}
